module.exports = __webpack_public_path__ + "img/img_floatingBanner.cd4aa433.png";